{
  "loadFailed": "Không thể tải thông tin thanh toán",
  "paymentCompleted": "Giao dịch hoàn tất",
  "unverifiedTradeFailed": "Giao dịch thất bại do chưa xác minh danh tính. Nếu cần hỗ trợ, vui lòng liên hệ bộ phận hỗ trợ.",
  "paymentFailed": "Thanh toán thất bại",
  "confirmPayment": "Xác nhận thanh toán",
  "myBalance": "Số dư của tôi",
  "bonusBalance": "Số dư thưởng",
  "totalPayable": "Tổng có thể thanh toán",
  "insufficientAvailableBalance": "Số dư khả dụng của bạn không đủ"
}
